import React from "react";
import { viewSupportsMultiCallView } from "components/History/views";
import { ConversationHistory } from "./ConversationHistory";
import { SessionDetails } from "components/SessionDetails";
import { SessionHistoryProps } from "./cfg";
// Message types
export function SessionHistory(props: SessionHistoryProps) {
  const { onClose, view, sessionId, phone_numbers, inView, enforceSessionView, onLoadIsViewingSet } = props;
  
  // If user loaded the page with a session ID in the URL, prioritize showing SessionDetails
  if (onLoadIsViewingSet && sessionId) {
    return <SessionDetails sessionId={sessionId} view={view} onClose={onClose} inView={inView} />;
  }
  if (!enforceSessionView && phone_numbers && phone_numbers.length > 0 && viewSupportsMultiCallView(view)) { 
    return <ConversationHistory {...props} /> 
  }
  if (sessionId) {
    return <SessionDetails sessionId={sessionId} view={view} onClose={onClose} inView={inView} />;
  }
  return null;
}